/* eslint-disable no-unused-vars */
import React, { useRef, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import LoadingCircle from 'components/ui/LoadingCircle';
import { sluggify } from 'utils/localization/utils';
import DocumentUpload from './DocumentUpload';
import { ACCEPTED_FILE_TYPES } from '../../../../config/accepted-file-types';
import {
  useHandleDeleteDocuments,
  useHandleUploadDocuments,
} from '../../../../utils/DocumentsHooks';
import { DELIVERY_ORDER } from '../../../../config/documents';
import { getFilesWithContentType } from 'utils/files/files';

export function BookingDeliveryOrder({ onUpload, onUploadFailed, onDelete }) {
  const [deliveryOrderDocument, setDeliveryOrderDocument] = useState(null);
  const dropzoneRef = useRef(null);
  const { t } = useTranslation();

  const handleDrop = async (files) => {
    const filesWithContentType = getFilesWithContentType(files);
    return handleUpload(
      filesWithContentType.map(
        (file) =>
          new File([file], DELIVERY_ORDER.name, {
            ...file.options,
            type: file.type,
          }),
      ),
      DELIVERY_ORDER.value,
    );
  };

  const { uploading, handleUpload } = useHandleUploadDocuments(
    null,
    null,
    async (shipment, stop, type, uploadedData, userVisibility) => {
      const document =
        uploadedData && uploadedData.length > 0 ? uploadedData[0] : null;

      setDeliveryOrderDocument(document);

      return onUpload?.(document);
    },
    (shipment, stop, e) => {
      console.log(e);

      return onUploadFailed?.(e);
    },
  );

  const { handleDelete } = useHandleDeleteDocuments((documents) => {
    setDeliveryOrderDocument(null);

    onDelete?.(documents);
  });

  return (
    <div className="">
      <h3 className="my-0 mb-4">{t('DELIVERY_ORDER')}</h3>
      {uploading && <LoadingCircle text={t('PROCESSING_FILES')} />}
      {deliveryOrderDocument && (
        <DocumentUpload
          className="mb-4"
          filename={deliveryOrderDocument.name}
          name={t(sluggify(deliveryOrderDocument.name))}
          onDelete={() => handleDelete([deliveryOrderDocument])}
        />
      )}
      <button
        className="text-sm text-blue-500 p-2"
        disabled={uploading}
        onClick={() => dropzoneRef.current?.open()}
      >
        {t('UPLOAD_DELIVERY_ORDER')}
      </button>

      <Dropzone
        style={{ display: 'none' }}
        ref={dropzoneRef}
        onDrop={handleDrop}
        accept={ACCEPTED_FILE_TYPES}
        multiple={false}
      >
        &nbsp;
      </Dropzone>
    </div>
  );
}
